import React from "react";
import PropTypes from "prop-types";
import styles from "./CommonCheckboxOpcao.module.css";

/**
 * Checkbox reutilizável para valores true ou false
 */
function CommonCheckboxOpcao({
  label,
  id,
  value,
  onChange,
  disabled = false,
  ...props
}) {
  return (
    <div className={`${styles.formCheck} ${disabled && styles.disabled}`}>
      <input
        className={styles.input}
        type="checkbox"
        id={id}
        name={id}
        checked={value}
        onChange={disabled ? null : onChange}
        disabled={disabled}
        {...props}
      />
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

CommonCheckboxOpcao.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default CommonCheckboxOpcao;
